var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dx-avatar"},[_c('img',{staticClass:"dx-avatar__avatar",attrs:{"src":_vm.avatarPath()}}),_vm._v(" "),(_vm.nickname)?_c('div',{staticClass:"dx-avatar__nickname"},[_vm._v("\n    "+_vm._s(_vm.nickname)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a3e142","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DxAvatar.vue
// module id = null
// module chunks = 